import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/shared/Layout';
import { Card, PageHeader } from '../../components/shared/ui';
import { companyAPI } from '../../utils/api';
import useAuthStore from '../../store/authStore';

const StatCard = ({ label, value, tone='blue' }) => {
  const tones = { blue:'text-brand-700', green:'text-emerald-600', violet:'text-violet-600' };
  return (
    <Card>
      <div className={`text-2xl sm:text-3xl font-bold ${tones[tone]}`}>{value}</div>
      <div className="text-xs sm:text-sm text-ink-500 mt-1">{label}</div>
    </Card>
  );
};

export const CompanyDashboard = () => {
  const { user } = useAuthStore();
  const [positions, setPositions] = useState([]);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    companyAPI.getProfile().then(r => setProfile(r.data)).catch(() => {});
    companyAPI.getPositions().then(r => setPositions(r.data)).catch(() => {});
  }, []);

  const totalMatches = positions.reduce((s, p) => s + (parseInt(p.matched_count) || 0), 0);
  const totalInvited = positions.reduce((s, p) => s + (parseInt(p.invited_count) || 0), 0);

  return (
    <Layout>
      <PageHeader title={profile?.name || 'Şirket Paneli'} description={user?.email} />

      {profile && !profile.is_approved && (
        <Card className="mb-6 border-amber-200 bg-amber-50">
          <div className="font-medium text-amber-900">Hesabınız onay bekliyor</div>
          <div className="text-sm text-amber-800 mt-1">Admin onayından sonra ilan oluşturabilir ve eşleştirme başlatabilirsiniz.</div>
        </Card>
      )}

      <div className="grid grid-cols-3 gap-3 sm:gap-4 mb-6">
        <StatCard label="Aktif İlan"        value={positions.filter(p => p.is_active).length} tone="blue" />
        <StatCard label="Toplam Eşleşme"    value={totalMatches} tone="violet" />
        <StatCard label="Davet Gönderildi"  value={totalInvited} tone="green" />
      </div>

      <Card>
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base font-semibold text-ink-900">İlanlar</h2>
          <Link to="/company/positions" className="text-sm text-brand-700 hover:text-brand-800">Tümünü Yönet →</Link>
        </div>
        {positions.slice(0,5).map(p => (
          <div key={p.id} className="flex items-center justify-between py-3 border-b border-ink-100 last:border-0 gap-3">
            <div className="font-medium text-sm text-ink-900 truncate">{p.title}</div>
            <Link to={`/company/candidates/${p.id}`} className="text-sm text-brand-700 hover:text-brand-800 whitespace-nowrap">
              {p.matched_count || 0} aday →
            </Link>
          </div>
        ))}
        {positions.length === 0 && (
          <p className="text-ink-400 text-sm text-center py-4">
            Henüz ilan yok. <Link to="/company/positions" className="text-brand-700 hover:text-brand-800">İlan Oluştur</Link>
          </p>
        )}
      </Card>
    </Layout>
  );
};

export default CompanyDashboard;
